import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";

const DiscountCoupon = () => {
  const navigate = useNavigate();
const coupons = [
  {
    id: 1,
    name: "Diwali Offer",
    code: "DIWALI10",
    discountType: "Percentage",
    discountValue: "10%",
    applicableItems: "Service 1, Category 2",
    validFrom: "25 August 2025",
    validTo: "30 August 2025",
    createdDate: "30 July 2025",
    active: true,
  },
  {
    id: 2,
    name: "New Year Blast",
    code: "NEWYEAR25",
    discountType: "Percentage",
    discountValue: "25%",
    applicableItems: "Service 2, Category 1",
    validFrom: "01 January 2026",
    validTo: "05 January 2026",
    createdDate: "20 December 2025",
    active: true,
  },
  {
    id: 3,
    name: "Weekend Saver",
    code: "WEEKEND50",
    discountType: "Flat",
    discountValue: "50 AED",
    applicableItems: "Service 1, Service 2",
    validFrom: "10 March 2026",
    validTo: "12 March 2026",
    createdDate: "01 March 2026",
    active: false,
  },
  {
    id: 4,
    name: "Ramadan Special",
    code: "RAMADAN15",
    discountType: "Percentage",
    discountValue: "15%",
    applicableItems: "Category 1, Category 2",
    validFrom: "15 April 2026",
    validTo: "15 May 2026",
    createdDate: "01 April 2026",
    active: true,
  },
  {
    id: 5,
    name: "Flash Hour Deal",
    code: "FLASH99",
    discountType: "Flat",
    discountValue: "99 AED",
    applicableItems: "Service 2",
    validFrom: "18 June 2026",
    validTo: "19 June 2026",
    createdDate: "16 June 2026",
    active: false,
  },
  {
    id: 6,
    name: "Mega Summer Sale",
    code: "SUMMER30",
    discountType: "Percentage",
    discountValue: "30%",
    applicableItems: "Service 1, Category 1, Category 2",
    validFrom: "01 July 2026",
    validTo: "10 July 2026",
    createdDate: "25 June 2026",
    active: true,
  },
  {
    id: 7,
    name: "Black Friday Max",
    code: "BLACKFRIDAY70",
    discountType: "Percentage",
    discountValue: "70%",
    applicableItems: "Service 2, Category 2",
    validFrom: "29 November 2026",
    validTo: "30 November 2026",
    createdDate: "01 November 2026",
    active: true,
  },
  {
    id: 8,
    name: "First Order Bonus",
    code: "WELCOME10",
    discountType: "Flat",
    discountValue: "10 AED",
    applicableItems: "All Services",
    validFrom: "01 January 2025",
    validTo: "31 December 2026",
    createdDate: "01 January 2025",
    active: true,
  },
  {
    id: 9,
    name: "Member Exclusive",
    code: "VIP40",
    discountType: "Percentage",
    discountValue: "40%",
    applicableItems: "Service 1, VIP Category",
    validFrom: "10 August 2026",
    validTo: "20 August 2026",
    createdDate: "08 August 2026",
    active: false,
  },
  {
    id: 10,
    name: "Happy Hour Deal",
    code: "HAPPY20",
    discountType: "Percentage",
    discountValue: "20%",
    applicableItems: "Category 1",
    validFrom: "04 October 2026",
    validTo: "10 October 2026",
    createdDate: "02 October 2026",
    active: true,
  }
];


  return (
    <>
      <div className="main_title">
        <h1>Discount & Coupon Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Discount & Coupon Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={""}
              setDebouncedSearchTerm={() => { }}
              placeholder="Search coupons..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/discount-coupon/add")}
            >
              Add Discount and Coupon
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Offer/Discount Name</TableCell>
                <TableCell>Coupon Code</TableCell>
                <TableCell>Discount Type</TableCell>
                <TableCell>Discount Value</TableCell>
                <TableCell>Applicable Services/Categories</TableCell>
                <TableCell>Valid From – To</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {coupons.map((item, index) => (
                <TableRow hover key={item.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.name}</TableCell>

                  <TableCell>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        borderColor: "#00B67A",
                        color: "#00B67A",
                        fontWeight: 600,
                        borderRadius: "6px",
                        px: 1.5,
                        py: 0.2,
                      }}
                    >
                      {item.code}
                    </Button>
                  </TableCell>

                  <TableCell>{item.discountType}</TableCell>

                  <TableCell>{item.discountValue}</TableCell>

                  <TableCell>{item.applicableItems}</TableCell>

                  <TableCell>
                    {item.validFrom} – {item.validTo}
                  </TableCell>

                  <TableCell>{item.createdDate}</TableCell>

                  <TableCell>
                    <SwitchToggle />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate('/discount-coupon/view')}>
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>

                      <IconButton onClick={() => navigate('/discount-coupon/add')}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </div>
    </>
  );
};

export default DiscountCoupon;
